/* Resolver landing page — behaviour.
   Each block is wrapped on its own, so one failing (a missing element, an
   old browser) cannot stop the rest of the page from working. */
(function () {
  if (!document.getElementById('resolver-page')) return;

  /* Height to keep clear at the top when the page scrolls to something:
     the Resolver bar (only while it is sticky) plus the theme's own sticky
     header, which is set in the theme editor. */
  window.RSVP_HEAD = function () {
    var root = document.getElementById('resolver-page');
    var off = root ? (parseFloat(root.getAttribute('data-head-offset')) || 0) : 0;
    var bar = document.querySelector('#resolver-page header.nav');
    var sticky = root && root.getAttribute('data-subnav-sticky') === 'true';
    return off + (bar && sticky ? bar.getBoundingClientRect().height : 0);
  };
})();
var RSVP_HEAD = window.RSVP_HEAD || function () { return 0; };

try {
(function(){
  var LI_CONVERSIONS = {
    trial: 31262105,   /* "Trial requested" */
    demo:  31262113    /* "Demo booking opened" */
  };

  function track(name, liKey, params){
    /* GA4. Consent Mode is already in force, so a visitor who declined
       analytics is recorded without cookies rather than not at all. */
    if(typeof gtag === 'function'){ gtag('event', name, params || {}); }

    /* LinkedIn. lintrk only exists once advertising consent arrived and the
       Insight Tag loaded, so this is a no-op for everybody else. */
    var id = LI_CONVERSIONS[liKey];
    if(id && typeof window.lintrk === 'function'){
      window.lintrk('track', { conversion_id: id });
    }
  }

  document.addEventListener('resolver:trial-submitted', function(){
    track('trial_requested', 'trial');
  });

  /* A click on the booking link, not a confirmed booking. Koalendar is a
     different domain and carries none of our tags, so whether they finished
     booking is not something this page can see. The event name says click
     for that reason — anyone reading the report should not mistake it for
     a diary entry. */
  document.addEventListener('resolver:demo-opened', function(){
    track('demo_booking_click', 'demo');
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ── Section 2 · the phase stack fits what is showing ────────────────────
   Mobile only. The phases are stacked in one grid cell, so CSS alone cannot
   size the cell to the visible one — this reads the height of whichever
   phase is currently faded in and hands it to the container. */
(function(){
  var box = document.querySelector('#solve .sv-phases');
  if(!box) return;
  if(!window.matchMedia) return;

  var small = window.matchMedia('(max-width:560px)');
  var timer = null;

  function visible(){
    var best = null, top = -1;
    [].forEach.call(box.children, function(p){
      var o = parseFloat(getComputedStyle(p).opacity) || 0;
      if(o > top){ top = o; best = p; }
    });
    return top > 0.45 ? best : null;
  }

  function fit(){
    var p = visible();
    if(!p) return;
    var h = p.scrollHeight;
    if(h && Math.abs(h - box.offsetHeight) > 2) box.style.height = h + 'px';
  }

  function start(){
    box.classList.add('sv-fit');
    fit();
    clearInterval(timer);
    timer = setInterval(fit, 260);
  }

  function stop(){
    clearInterval(timer);
    timer = null;
    box.classList.remove('sv-fit');
    box.style.height = '';
  }

  function apply(){ if(small.matches) start(); else stop(); }

  if(small.addEventListener) small.addEventListener('change', apply);
  else if(small.addListener) small.addListener(apply);

  /* only while the section is actually being looked at */
  var sec = document.getElementById('solve');
  if(sec && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting) apply(); else clearInterval(timer); });
    }, {threshold:0.2}).observe(sec);
  } else {
    apply();
  }
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ── Section 3 · the card carousel moves on its own ──────────────────────
   Only on touch screens, where the deck is one card wide and the rest are
   off to the side. It stops for good as soon as the visitor takes hold of
   it — an auto-scroller that fights the thumb is worse than none. */
(function(){
  var sec = document.getElementById('why');
  if(!sec) return;
  if(!window.matchMedia || !window.matchMedia('(hover:none)').matches) return;
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

  var DWELL = 6000, timer = null, stopped = false, inView = false;

  function panel(){ return sec.querySelector('.r3-panel.on'); }

  function step(){
    if(stopped || !inView) return;
    var p = panel();
    if(!p) return;
    var cards = [].slice.call(p.querySelectorAll('.r3-card'));
    if(cards.length < 2) return;

    /* whichever card is nearest the middle right now is "current" */
    var mid = p.scrollLeft + p.clientWidth / 2, at = 0, best = Infinity;
    cards.forEach(function(c, k){
      var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
      if(d < best){ best = d; at = k; }
    });

    var nxt = cards[(at + 1) % cards.length];
    var left = nxt.offsetLeft - (p.clientWidth - nxt.offsetWidth) / 2;
    if(p.scrollTo) p.scrollTo({left:left, behavior:'smooth'});
    else p.scrollLeft = left;
    if(window.resolverWhyActivate) window.resolverWhyActivate(nxt);
  }

  function halt(){ stopped = true; clearInterval(timer); }
  function arm(){ clearInterval(timer); if(!stopped) timer = setInterval(step, DWELL); }

  ['touchstart','pointerdown','wheel'].forEach(function(ev){
    sec.addEventListener(ev, halt, {passive:true, once:true});
  });
  [].forEach.call(sec.querySelectorAll('.r3-arw, .r3-navi'), function(b){
    b.addEventListener('click', halt);
  });

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        inView = e.isIntersecting;
        if(inView) arm(); else clearInterval(timer);
      });
    }, {threshold:0.3}).observe(sec);
  } else {
    inView = true; arm();
  }
})();

/* ── the demo videos open full screen ────────────────────────────────────
   Played inline they are a phone-sized window onto a desktop screenshot,
   which is unreadable. Going full screen on play makes them legible. iOS
   Safari exposes its own method on the video element rather than the
   standard one, and every call has to sit inside the user's own gesture,
   which the play event still counts as. */
(function(){
  var vids = [].slice.call(document.querySelectorAll('video.vv'));
  if(!vids.length) return;

  function already(){
    return document.fullscreenElement || document.webkitFullscreenElement ||
           document.webkitDisplayingFullscreen;
  }

  vids.forEach(function(v){
    v.addEventListener('play', function(){
      if(already()) return;
      try {
        if(v.requestFullscreen) v.requestFullscreen().catch(function(){});
        else if(v.webkitEnterFullscreen) v.webkitEnterFullscreen();
        else if(v.webkitRequestFullscreen) v.webkitRequestFullscreen();
      } catch(e) {}
    });

    /* Leaving full screen should not leave it playing out of sight. */
    v.addEventListener('webkitendfullscreen', function(){ v.pause(); });
  });

  document.addEventListener('fullscreenchange', function(){
    if(document.fullscreenElement) return;
    vids.forEach(function(v){ if(!v.paused) v.pause(); });
  });
})();

/* ── the client logo strip drifts on a phone ─────────────────────────────
   A slow, continuous nudge rather than a jump, so it reads as a ribbon.
   The arrows still work, and any touch stops the drift for good. */
(function(){
  var track = document.getElementById('kk-ctrack');
  if(!track) return;
  if(!window.matchMedia || !window.matchMedia('(hover:none)').matches) return;
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

  /* Pixels per second, not per frame, so the speed is the same on a 60Hz
     and a 120Hz screen. */
  var SPEED = 22, raf = null, last = 0, pos = 0;
  var stopped = false, inView = false, back = false;

  /* Two things to get right here. The track has scroll-behavior:smooth for
     the arrows, which swallows small nudges — so drive it directly and hand
     smooth scrolling back when the drift stops. And scrollLeft snaps to the
     device pixel grid when read back, so a sub-pixel step added to the
     element's own value rounds away to nothing: keep the true position in a
     variable and write that. */
  track.style.scrollBehavior = 'auto';

  function drift(now){
    raf = null;
    if(stopped || !inView) return;
    var dt = last ? Math.min(now - last, 64) : 16;
    last = now;

    var max = track.scrollWidth - track.clientWidth;
    if(max > 1){
      pos += (back ? -1 : 1) * SPEED * dt / 1000;
      if(pos >= max){ pos = max; back = true; }
      else if(pos <= 0){ pos = 0; back = false; }
      track.scrollLeft = pos;
    }
    raf = requestAnimationFrame(drift);
  }

  function halt(){
    stopped = true;
    if(raf) cancelAnimationFrame(raf);
    raf = null;
    track.style.scrollBehavior = '';
  }

  function arm(){
    if(stopped || raf) return;
    pos = track.scrollLeft;
    last = 0;
    raf = requestAnimationFrame(drift);
  }

  function pause(){ if(raf) cancelAnimationFrame(raf); raf = null; }

  ['touchstart','pointerdown','wheel'].forEach(function(ev){
    track.addEventListener(ev, halt, {passive:true, once:true});
  });
  /* capture, so smooth scrolling is restored before the arrow's own handler
     runs and the first press animates like every one after it */
  [].forEach.call(document.querySelectorAll('.kk-carw'), function(b){
    b.addEventListener('click', halt, true);
  });

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        inView = e.isIntersecting;
        if(inView) arm(); else pause();
      });
    }, {threshold:0.4}).observe(track);
  } else {
    inView = true; arm();
  }
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ── Section 2 · "Watch it solve" ────────────────────────────────────────
   Added by script so the markup stays as it is if this never runs. One
   button per panel, each jumping to its own visual rather than a fixed
   target, so it stays correct whichever state is showing. */
(function(){
  var sec = document.getElementById('solve');
  if(!sec || sec.querySelector('.sv-jump')) return;

  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" '
            + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
            + '<path d="M12 4.5v14M5.5 12.5 12 19l6.5-6.5"/></svg>';

  [].slice.call(sec.querySelectorAll('.sv-panel')).forEach(function(panel){
    var lede = panel.querySelector('.sv-copy .sv-body');
    var vis  = panel.querySelector('.sv-vis');
    if(!lede || !vis) return;

    if(!vis.id) vis.id = panel.id + '-vis';

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sv-jump';
    b.setAttribute('aria-controls', vis.id);
    b.innerHTML = '<span>Watch it solve</span>' + ARROW;

    b.addEventListener('click', function(){
      /* Clear the sticky header so the visual does not open underneath it. */
      var head = document.querySelector('header.nav');
      var off  = RSVP_HEAD() + 14;
      var y    = vis.getBoundingClientRect().top + window.pageYOffset - off;
      var soft = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
      window.scrollTo({top: Math.max(0, y), behavior: soft ? 'smooth' : 'auto'});
    });

    lede.parentNode.insertBefore(b, lede.nextSibling);
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ── Section 2 · arrows beside the tab row ───────────────────────────────
   The row scrolls, but on a phone only two tabs are ever in sight and the
   rest are easy to miss. These step through the five states one at a time
   and wrap at each end. Built here rather than in the markup so the tab
   row keeps working untouched if the script never runs. */
(function(){
  var row = document.querySelector('#solve .sv-tabs');
  if(!row || document.querySelector('.sv-tabw')) return;

  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" '
           + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
           + '<path d="M%s"/></svg>';

  function arrow(dir, label, path){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sv-tarw';
    b.setAttribute('aria-label', label);
    b.innerHTML = CHEV.replace('%s', path);
    b.addEventListener('click', function(){
      if(window.resolverSolveStep) window.resolverSolveStep(dir);
    });
    return b;
  }

  var wrap = document.createElement('div');
  wrap.className = 'sv-tabw';
  row.parentNode.insertBefore(wrap, row);
  wrap.appendChild(arrow(-1, 'Previous', '15 5l-7 7 7 7'));
  wrap.appendChild(row);
  wrap.appendChild(arrow(1, 'Next', '9 5l7 7-7 7'));
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==TABS-SNAP-JS== */
/* ── Section 2 · the tab row selects what you swipe to ───────────────────
   The tab nearest the middle of the row wins, once the scroll has settled.
   Guarded so that only a scroll the visitor began can change the state: the
   section scrolls this row itself on every state change, and that must not
   come back round as a second selection. */
(function(){
  var row = document.querySelector('#solve .sv-tabs');
  if(!row) return;

  var tabs = [].slice.call(row.querySelectorAll('.sv-tab'));
  if(tabs.length < 2) return;

  var mine = false, tid = null;

  ['touchstart','pointerdown','wheel'].forEach(function(ev){
    row.addEventListener(ev, function(){ mine = true; }, {passive:true});
  });

  function settle(){
    if(!mine) return;
    if(row.scrollWidth - row.clientWidth < 4) return;   /* nothing to swipe */
    var mid = row.scrollLeft + row.clientWidth / 2, at = null, best = Infinity;
    tabs.forEach(function(t){
      var d = Math.abs((t.offsetLeft + t.offsetWidth / 2) - mid);
      if(d < best){ best = d; at = t; }
    });
    mine = false;
    if(at && at.getAttribute('aria-selected') !== 'true') at.click();
  }

  row.addEventListener('scroll', function(){
    clearTimeout(tid);
    tid = setTimeout(settle, 130);
  }, {passive:true});
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==WHY-CARDS-JS== */
/* ── Section 3 · the cards ───────────────────────────────────────────────
   Arrows for the card row, and the centred card opening itself. Both wait
   for the section's own script to publish window.resolverWhyActivate, so
   this runs at DOMContentLoaded rather than at parse time. */
(function(){
  function boot(){
    var sec = document.getElementById('why');
    if(!sec || sec.querySelector('.r3-carws')) return;
    var host = sec.querySelector('.r3-arws');
    if(!host || !host.parentNode) return;

    var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" '
             + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
             + '<path d="%p"/></svg>';

    function panel(){ return sec.querySelector('.r3-panel.on') || sec.querySelector('.r3-panel'); }
    function cards(p){ return [].slice.call(p.querySelectorAll('.r3-card')); }

    /* whichever card is nearest the middle of the row is the one on show */
    function at(p, cs){
      var mid = p.scrollLeft + p.clientWidth / 2, k = 0, best = Infinity;
      cs.forEach(function(c, i){
        var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
        if(d < best){ best = d; k = i; }
      });
      return k;
    }

    function show(c, p){
      var left = Math.max(0, c.offsetLeft - (p.clientWidth - c.offsetWidth) / 2);
      var soft = !(window.matchMedia
                   && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
      if(p.scrollTo) p.scrollTo({left:left, behavior: soft ? 'smooth' : 'auto'});
      else p.scrollLeft = left;
      if(window.resolverWhyActivate) window.resolverWhyActivate(c);
    }

    function step(dir){
      var p = panel(); if(!p) return;
      var cs = cards(p); if(cs.length < 2) return;
      show(cs[Math.min(Math.max(at(p, cs) + dir, 0), cs.length - 1)], p);
    }

    function arrow(label, path, dir){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'r3-carw';
      b.setAttribute('aria-label', label);
      b.setAttribute('aria-controls', 'r3-deck');
      b.innerHTML = CHEV.replace('%p', path);
      b.addEventListener('click', function(){ step(dir); });
      return b;
    }

    var prev = arrow('Previous card', 'M15 5l-7 7 7 7', -1);
    var next = arrow('Next card', 'M9 5l7 7-7 7', 1);

    var wrap = document.createElement('div');
    wrap.className = 'r3-carws';
    wrap.appendChild(prev);
    wrap.appendChild(next);
    host.parentNode.insertBefore(wrap, host.nextSibling);

    /* ── the middle card opens itself ── */
    var wide = window.matchMedia ? window.matchMedia('(min-width:861px)') : null;
    var tid = null, last = null;

    function settle(){
      var p = panel(); if(!p) return;
      var cs = cards(p); if(!cs.length) return;
      var k = at(p, cs);
      prev.disabled = k <= 0;
      next.disabled = k >= cs.length - 1;
      if(wide && wide.matches) return;      /* desktop keeps hover and click */
      var c = cs[k];
      if(c && c !== last){
        last = c;
        if(window.resolverWhyActivate) window.resolverWhyActivate(c);
      }
    }
    function later(ms){ clearTimeout(tid); tid = setTimeout(settle, ms); }

    [].forEach.call(sec.querySelectorAll('.r3-panel'), function(p){
      p.addEventListener('scroll', function(){ later(90); }, {passive:true});
    });
    /* a group change brings a different row of cards with it */
    [].forEach.call(sec.querySelectorAll('.r3-navi, .r3-arw, .r3-tarw'), function(b){
      b.addEventListener('click', function(){ last = null; later(70); });
    });
    window.addEventListener('resize', function(){ later(160); });

    settle();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==WHY-ARROWS-JS== */
/* ── Section 3 · arrows beside the group buttons ─────────────────────────
   Built here so the markup is untouched. Each one clicks the section's own
   previous/next control rather than reimplementing the step, so everything
   downstream of a group change keeps working. */
(function(){
  var row = document.querySelector('#why .r3-nav');
  if(!row || document.querySelector('.r3-navw')) return;

  var prev = document.getElementById('r3-prev');
  var next = document.getElementById('r3-next');
  if(!prev || !next) return;

  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" '
           + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
           + '<path d="M%s"/></svg>';

  function arrow(target, label, path){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'r3-tarw';
    b.setAttribute('aria-label', label);
    b.innerHTML = CHEV.replace('%s', path);
    b.addEventListener('click', function(){ target.click(); });
    return b;
  }

  var wrap = document.createElement('div');
  wrap.className = 'r3-navw';
  row.parentNode.insertBefore(wrap, row);
  wrap.appendChild(arrow(prev, 'Previous', '15 5l-7 7 7 7'));
  wrap.appendChild(row);
  wrap.appendChild(arrow(next, 'Next', '9 5l7 7-7 7'));
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==SOLVE-SWIPE-JS== */
/* ── Section 2 · swipe between states ────────────────────────────────────
   Same gesture rules as the hero deck: far enough, mostly horizontal, not a
   slow drag that was really an attempt to scroll the page. */
(function(){
  var deck = document.querySelector('#solve .sv-deck');
  if(!deck || !window.matchMedia || !window.matchMedia('(hover:none)').matches) return;

  var x0 = null, y0 = 0, t0 = 0;

  deck.addEventListener('touchstart', function(ev){
    if(ev.touches.length !== 1){ x0 = null; return; }
    x0 = ev.touches[0].clientX;
    y0 = ev.touches[0].clientY;
    t0 = Date.now();
  }, {passive:true});

  deck.addEventListener('touchend', function(ev){
    if(x0 === null) return;
    var t = ev.changedTouches[0];
    var dx = t.clientX - x0, dy = t.clientY - y0;
    x0 = null;
    if(Math.abs(dx) < 50) return;
    if(Math.abs(dx) < Math.abs(dy) * 1.6) return;
    if(Date.now() - t0 > 800) return;
    if(window.resolverSolveStep) window.resolverSolveStep(dx < 0 ? 1 : -1);
  }, {passive:true});
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==MOBILE-NAV-JS== */
/* ── the header on a phone ───────────────────────────────────────────────
   The desktop header's links and CTA are hidden at narrow widths, which
   left nothing to act on. A compact trial button and a section menu, both
   assembled here rather than added to the markup. */
(function(){
  var head = document.querySelector('header.nav');
  var inner = head && head.querySelector('.nav-in');
  if(!head || !inner || head.querySelector('.nav-mob')) return;

  /* Every section worth jumping to, in page order. The four the desktop
     header shows, plus the two below them that a visitor on a long phone
     page is most likely to be hunting for. */
  var LINKS = [
    ['#solve',  'What it solves'],
    ['#why',    'Why Resolver'],
    ['#see',    'See it in action'],
    ['#human',  'AI + Human'],
    ['#value',  'The future of IT'],
    ['#proof',  'Powered by Klyk']
  ].filter(function(l){ return document.querySelector(l[0]); });

  var wrap = document.createElement('div');
  wrap.className = 'nav-mob';

  /* ── the button ── */
  var cta = document.createElement('a');
  cta.className = 'btn btn-orange nav-mcta';
  cta.href = '#start';
  cta.textContent = 'Try free';
  wrap.appendChild(cta);

  /* ── the menu ── */
  var burger = document.createElement('button');
  burger.type = 'button';
  burger.className = 'nav-burger';
  burger.setAttribute('aria-expanded', 'false');
  burger.setAttribute('aria-controls', 'nav-sheet');
  burger.setAttribute('aria-label', 'Open the section menu');
  burger.innerHTML = '<span class="nav-bars" aria-hidden="true"><i></i><i></i><i></i></span>';
  wrap.appendChild(burger);

  inner.appendChild(wrap);

  var sheet = document.createElement('nav');
  sheet.className = 'nav-sheet';
  sheet.id = 'nav-sheet';
  sheet.setAttribute('aria-label', 'Sections');
  sheet.hidden = true;
  LINKS.forEach(function(l){
    var a = document.createElement('a');
    a.href = l[0];
    a.textContent = l[1];
    sheet.appendChild(a);
  });
  head.appendChild(sheet);

  function open(){
    sheet.hidden = false;
    /* next frame, so the transition has a closed state to run from */
    requestAnimationFrame(function(){ head.classList.add('nav-open'); });
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close the section menu');
  }

  function shut(){
    head.classList.remove('nav-open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open the section menu');
    /* keep it in the tree until the slide finishes, then out of tab order */
    setTimeout(function(){ if(!head.classList.contains('nav-open')) sheet.hidden = true; }, 260);
  }

  function toggle(){
    if(head.classList.contains('nav-open')) shut(); else open();
  }

  burger.addEventListener('click', toggle);
  sheet.addEventListener('click', function(e){ if(e.target.tagName === 'A') shut(); });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && head.classList.contains('nav-open')){ shut(); burger.focus(); }
  });

  document.addEventListener('click', function(e){
    if(!head.classList.contains('nav-open')) return;
    if(head.contains(e.target)) return;
    shut();
  });

  /* a resize into desktop width should not leave an open sheet behind */
  window.addEventListener('resize', function(){
    if(window.innerWidth > 1180 && head.classList.contains('nav-open')) shut();
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==DEMO-CTA-JS== */
/* ── "Book a live demo" ──────────────────────────────────────────────────
   Two jobs, and the first one runs whatever the button points at:

   1. Count the click. The button is the only demo request we can see, so the
      event fires before anything else happens and regardless of destination.
      It is a request, not a booking — whether they finish is not visible
      from this page.

   2. Where the button points at a booking page (data-fallback present), keep
      it working if the browser refuses the new tab. That is the only failure
      a page can detect across origins; a 404 or an outage on the far end is
      invisible from here, which is why the Koalendar page going down needed a
      person to notice rather than a script.

   With the button set to email — no data-fallback — only job 1 runs
   and the mailto is left entirely to the browser. */
(function(){
  var a = document.getElementById('demo-cta');
  if(!a) return;

  a.addEventListener('click', function(ev){
    /* let the browser handle the ways people deliberately open links
       differently: new window, background tab, download, context menu */
    if(ev.defaultPrevented || ev.button !== 0 ||
       ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;

    try {
      document.dispatchEvent(new CustomEvent('resolver:demo-opened'));
    } catch(e) {}

    var fallback = a.getAttribute('data-fallback');
    if(!fallback) return;          /* email-only: nothing further to do */

    /* No 'noopener' in the features string, deliberately.
       Passing it makes window.open return null *by design* — severing the
       reference is the whole point of the flag — so the tab opened, we read
       null, concluded the browser had refused, and sent them to the email as
       well. Both happened on every click.

       The reference is severed on the next line instead, which is the same
       protection with a usable return value. */
    var win;
    try { win = window.open(a.href, '_blank'); } catch(e) { win = null; }

    if(win){
      /* it opened; stop the browser opening a second copy */
      ev.preventDefault();
      try { win.opener = null; } catch(e){}
      return;
    }

    /* blocked. Send them to the email instead, in this tab, and say so —
       silently swapping the destination on someone is worse than the
       original problem. */
    ev.preventDefault();
    if(window.console){
      console.warn('The booking page could not be opened in a new tab '
                   + '(pop-up blocked). Falling back to email.');
    }
    window.location.href = fallback;
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==VID-PLAY-JS== */
/* Hide the badge while a film runs. The badge is CSS on .ph, so all this does
   is put a class on the card; with the script off you get a badge that stays
   put over a playing film, which is untidy but harmless, and the film still
   plays. */
(function(){
  [].forEach.call(document.querySelectorAll('.vid video'), function(v){
    var card = v.closest ? v.closest('.vid') : null;
    if(!card) return;
    var on  = function(){ card.classList.add('vplaying'); };
    var off = function(){ card.classList.remove('vplaying'); };
    v.addEventListener('play', on);
    v.addEventListener('playing', on);
    v.addEventListener('ended', off);
    /* a pause part-way through leaves the badge off: the controls are already
       showing at that point, and two play affordances at once is worse than
       one */
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==MOBILE-UX2-JS== */
/* ── back to the top ─────────────────────────────────────────────────────
   Built here so the markup needs nothing. It is shown by the footer coming
   into view rather than by a scroll distance, so it stays correct however
   long the page becomes. */
(function(){
  var foot = document.querySelector('footer');
  if(!foot || document.querySelector('.totop')) return;

  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'totop';
  b.setAttribute('aria-label', 'Back to the top of the page');
  b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" '
              + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
              + '<path d="M12 19.5v-15M5.5 11 12 4.5 18.5 11"/></svg>';
  b.addEventListener('click', function(){
    var soft = !(window.matchMedia
                 && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
    window.scrollTo({top:0, behavior: soft ? 'smooth' : 'auto'});
    var skip = document.getElementById('top');
    if(skip && skip.focus) { try { skip.focus({preventScroll:true}); } catch(e){} }
  });
  (document.getElementById('resolver-page') || document.body).appendChild(b);

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(e){ b.classList.toggle('show', e.isIntersecting); });
    }, {threshold:0}).observe(foot);
  } else {
    b.classList.add('show');
  }

  /* stay clear of the sticky CTA bar while it is up */
  var bar = document.querySelector('.mobilebar');
  if(bar && window.MutationObserver){
    var lift = function(){ b.classList.toggle('up', bar.classList.contains('show')); };
    new MutationObserver(lift).observe(bar, {attributes:true, attributeFilter:['class']});
    lift();
  }
})();

/* ── every trial button lands on the whole form ──────────────────────────
   The plain #start anchor puts the top of the section under the header, and
   the form card is taller than what is left of the screen, so the button and
   the line under it fell below the fold — you arrived at a form you could not
   finish without scrolling again.

   This lands on the card itself, and where the card fits in the space below
   the header it aligns the BOTTOM to the fold instead of the top, so the whole
   thing is on screen at once. Where it does not fit — a phone, a short window —
   it falls back to the top, which is the best available.

   Delegated from the document so buttons the page builds later (the header CTA
   on a phone) are covered too. The hrefs are untouched, so every one of them
   still works with the script off. */
(function(){
  var GAP = 18;

  /* Best frame first, falling back as the window gets shorter:
       the whole card (heading, inclusions, fields, button)
       → the form alone (fields and button)
       → the top of the form, when even that will not fit.
     On a phone the card's own header is a screenful before the first field,
     so the card is skipped and the form is the first thing tried. */
  function frames(){
    var wide = window.matchMedia && window.matchMedia('(min-width:901px)').matches;
    var card = document.querySelector('.tr-card');
    var form = document.getElementById('demoform');
    var out = [];
    if(wide && card) out.push(card);
    if(form) out.push(form);
    if(!out.length){
      var sec = document.getElementById('start');
      if(sec) out.push(sec);
    }
    return out;
  }

  document.addEventListener('click', function(ev){
    if(ev.defaultPrevented || ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
    var a = ev.target.closest ? ev.target.closest('a[href="#start"]') : null;
    if(!a) return;

    var list = frames();
    if(!list.length) return;
    ev.preventDefault();

    var head  = document.querySelector('header.nav');
    var headH = RSVP_HEAD();
    var room  = window.innerHeight - headH - GAP * 2;

    /* the first frame that fits wins; if none do, use the last one's top */
    var el = list[list.length - 1], fits = false, i;
    for(i = 0; i < list.length; i++){
      if(list[i].getBoundingClientRect().height <= room){ el = list[i]; fits = true; break; }
    }

    var box    = el.getBoundingClientRect();
    var top    = box.top + window.pageYOffset;
    var bottom = top + box.height;

    /* Aligning the bottom is always a shorter scroll than aligning the top,
       so a frame that fits gives you all of it AND as much of the section
       heading above it as will still show. */
    var y = fits ? bottom - window.innerHeight + GAP
                 : top - headH - GAP;

    var soft = !(window.matchMedia
                 && window.matchMedia('(prefers-reduced-motion:reduce)').matches);
    window.scrollTo({top: Math.max(0, y), behavior: soft ? 'smooth' : 'auto'});

    /* move the reading position without opening the keyboard */
    var form = document.getElementById('demoform');
    if(form){
      form.setAttribute('tabindex', '-1');
      try { form.focus({preventScroll:true}); } catch(e){}
    }
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ==MOBILE-UX-JS== */
/* ── the sticky CTA bar ──────────────────────────────────────────────────
   It only earns its place once the hero's own button is gone. Watching the
   hero button itself rather than a scroll distance keeps it correct at every
   screen height and after any copy change above it. */
(function(){
  var bar = document.querySelector('.mobilebar');
  var cta = document.querySelector('.hero-actions');
  if(!bar || !cta) return;

  if(!('IntersectionObserver' in window)){ bar.classList.add('show'); return; }

  /* Dismissal lasts the browsing session: scrolling back up and down again
     should not bring back something the visitor has just closed. */
  var KEY = 'resolver-cta-dismissed';
  var dismissed = false;
  try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch(e) {}

  function hide(){
    dismissed = true;
    bar.classList.remove('show');
    try { sessionStorage.setItem(KEY, '1'); } catch(e) {}
  }

  /* a close control, added here so the markup needs nothing */
  if(!bar.querySelector('.mb-x')){
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'mb-x';
    x.setAttribute('aria-label', 'Hide this bar');
    x.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" '
                + 'stroke-width="2" stroke-linecap="round" aria-hidden="true">'
                + '<path d="M6 6l12 12M18 6 6 18"/></svg>';
    x.addEventListener('click', hide);
    bar.appendChild(x);
  }

  /* and a downward swipe on the bar itself */
  var y0 = null, x0 = 0, t0 = 0;
  bar.addEventListener('touchstart', function(ev){
    if(ev.touches.length !== 1){ y0 = null; return; }
    y0 = ev.touches[0].clientY;
    x0 = ev.touches[0].clientX;
    t0 = Date.now();
  }, {passive:true});
  bar.addEventListener('touchend', function(ev){
    if(y0 === null) return;
    var t = ev.changedTouches[0];
    var dy = t.clientY - y0, dx = t.clientX - x0;
    y0 = null;
    if(dy > 40 && Math.abs(dy) > Math.abs(dx) * 1.5 && Date.now() - t0 < 800) hide();
  }, {passive:true});

  new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      /* show only when the hero button has gone UP past the top of the
         screen — never while it is still below the fold on first paint */
      var gone = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('show', gone && !dismissed);
    });
  }, {threshold:0}).observe(cta);
})();

/* ── swipe the hero chat deck ────────────────────────────────────────────
   Horizontal swipes move between Slack, Teams and Google Chat. Vertical
   movement is left alone so the page still scrolls normally, and the
   auto-rotation carries on afterwards from the slide you landed on. */
(function(){
  var deck = document.getElementById('deck');
  if(!deck || !window.matchMedia || !window.matchMedia('(hover:none)').matches) return;

  var x0 = null, y0 = null, t0 = 0;

  deck.addEventListener('touchstart', function(ev){
    if(ev.touches.length !== 1){ x0 = null; return; }
    x0 = ev.touches[0].clientX;
    y0 = ev.touches[0].clientY;
    t0 = Date.now();
  }, {passive:true});

  deck.addEventListener('touchend', function(ev){
    if(x0 === null) return;
    var t = ev.changedTouches[0];
    var dx = t.clientX - x0, dy = t.clientY - y0;
    x0 = null;
    /* a deliberate sideways flick: far enough, mostly horizontal, not a
       slow drag that was really an attempt to scroll */
    if(Math.abs(dx) < 45) return;
    if(Math.abs(dx) < Math.abs(dy) * 1.6) return;
    if(Date.now() - t0 > 800) return;
    if(window.resolverDeckStep) window.resolverDeckStep(dx < 0 ? 1 : -1);
  }, {passive:true});
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
(function(){
  /* The review toggle only exists on internal builds. Guard the toggle, not
     the whole script — everything below it (persona tabs, hero chat deck)
     has to run either way. */
  var t=document.getElementById('anno');
  if(t){
    t.addEventListener('click',function(){
      var on=t.getAttribute('aria-pressed')==='true';
      t.setAttribute('aria-pressed',String(!on));
      document.body.classList.toggle('annotate',!on);
    });
  }
  var tabs=[].slice.call(document.querySelectorAll('.tab'));
  tabs.forEach(function(b){
    b.addEventListener('click',function(){
      tabs.forEach(function(o){
        o.setAttribute('aria-selected',String(o===b));
        var pp=document.getElementById(o.dataset.p); if(pp) pp.hidden=(o!==b);
      });
    });
  });
  var ptabs=[].slice.call(document.querySelectorAll('.ptab'));
  ptabs.forEach(function(b){
    b.addEventListener('click',function(){
      ptabs.forEach(function(o){
        o.setAttribute('aria-selected',String(o===b));
        var pv=document.getElementById(o.dataset.v); if(pv) pv.classList.toggle('on',o===b);
      });
    });
  });

  // chat deck
  var deck=document.getElementById('deck');
  var slides=[].slice.call(deck.querySelectorAll('.slide'));
  var dots=[].slice.call(document.querySelectorAll('.deck-nav button'));
  var i=0, timer=null, paused=false, stopped=false;
  var slow=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var chatTimers=[];
  function playChat(slide){
    chatTimers.forEach(clearTimeout); chatTimers=[];
    if(slow){ slide.classList.remove('anim'); return; }
    slide.classList.add('anim');
    var cues=[].slice.call(slide.querySelectorAll('[data-d]'));
    cues.forEach(function(el){ el.classList.remove('in'); });
    void slide.offsetWidth;                       // restart the pop animations
    cues.forEach(function(el){
      chatTimers.push(setTimeout(function(){ el.classList.add('in'); }, +el.dataset.d));
      if(el.dataset.h) chatTimers.push(setTimeout(function(){ el.classList.remove('in'); }, +el.dataset.h));
    });
  }
  function go(n){
    i=(n+slides.length)%slides.length;
    slides.forEach(function(s,k){s.classList.toggle('on',k===i);});
    dots.forEach(function(d,k){d.setAttribute('aria-current',String(k===i));});
    playChat(slides[i]);
  }
  function loop(){
    if(!paused){
      /* Once the visitor has chosen a platform we keep that choice, but the
         conversation still replays so the hero never sits frozen. */
      if(stopped) playChat(slides[i]); else go(i+1);
    }
    timer=setTimeout(loop, 14000);
  }
  // once the visitor chooses a platform, stop cycling — the choice is theirs to keep
  dots.forEach(function(d){ d.addEventListener('click',function(){ stopped=true; clearTimeout(timer); go(+d.dataset.go); timer=setTimeout(loop, 14000); }); });
  /* Pause on hover only where hovering is a real thing. On a touch screen
     mouseenter fires on tap and mouseleave often never does, which is what
     left the deck paused for good. */
  if(window.matchMedia && window.matchMedia('(hover:hover)').matches){
    deck.addEventListener('mouseenter',function(){paused=true;});
    deck.addEventListener('mouseleave',function(){paused=false;});
  }
  /* A hidden tab should not burn through slides, and coming back to it must
     never leave the deck stuck. */
  document.addEventListener('visibilitychange',function(){
    clearTimeout(timer);
    if(!document.hidden && !slow){ paused=false; timer=setTimeout(loop, 4000); }
  });
  /* Let the swipe handler drive the same code path the timer uses, so a
     swipe and an auto-advance behave identically and the clock restarts. */
  window.resolverDeckStep = function(dir){
    clearTimeout(timer);
    go(i + dir);
    timer = setTimeout(loop, 14000);
  };

  playChat(slides[0]);
  if(!slow) timer=setTimeout(loop, 9000);
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
(function(){
  var sec = document.getElementById('solve');
  if(!sec) return;

  /* One source of truth for which state is showing: the section's data-s
     attribute drives every accent through CSS custom properties, so a tab
     change recolours tabs, copy, product UI, message card and ambient
     shapes in one assignment. */
  var tabs   = [].slice.call(sec.querySelectorAll('.sv-tab'));
  var panels = tabs.map(function(t){ return document.getElementById(t.getAttribute('aria-controls')); });
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var current = 0, inView = false, auto = null, stopped = false, autoMove = false;

  /* Removing .play strips every animation-name, dropping each element back
     to its finished CSS state; the forced reflow guarantees that re-adding
     it starts a brand-new run, so a tab always replays from frame one. */
  function play(i){
    panels.forEach(function(p){ if(p) p.classList.remove('play'); });
    if(reduce.matches || !inView) return;
    var p = panels[i];
    if(!p) return;
    void p.offsetWidth;
    p.classList.add('play');
  }

  /* Bring the active tab into view inside its own scroller. An
     auto-advance must never scroll the page itself — the visitor may be
     reading the panel with the tab row already above them. */
  function revealTab(i, pageToo){
    var t = tabs[i], row = t.parentNode;
    if(row && row.scrollWidth > row.clientWidth + 1){
      var left = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
      if(row.scrollTo) row.scrollTo({left:left, behavior:'smooth'});
      else row.scrollLeft = left;
    } else if(pageToo){
      t.scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'});
    }
  }

  function select(i, focus){
    var same = (i === current);
    current = i;
    sec.setAttribute('data-s', String(i));
    tabs.forEach(function(t,k){
      t.setAttribute('aria-selected', String(k===i));
      t.tabIndex = k===i ? 0 : -1;
      if(panels[k]) panels[k].classList.toggle('on', k===i);
    });
    if(focus) tabs[i].focus();
    if(!same || !focus) revealTab(i, !autoMove);
    play(i);
  }

  tabs.forEach(function(t,i){
    t.addEventListener('click', function(){ halt(); select(i); });
    t.addEventListener('keydown', function(e){
      var n = null;
      if(e.key==='ArrowRight') n = (i+1) % tabs.length;
      else if(e.key==='ArrowLeft') n = (i-1+tabs.length) % tabs.length;
      else if(e.key==='Home') n = 0;
      else if(e.key==='End') n = tabs.length-1;
      if(n!==null){ e.preventDefault(); halt(); select(n, true); }
    });
  });

  /* Deep links, so a campaign can land on the matching state. */
  var map = {'#fixes':0,'#diagnosis':1,'#self-healing':2,'#expert':3};
  function fromHash(){
    var i = map[window.location.hash];
    if(i!==undefined) select(i);
  }
  window.addEventListener('hashchange', fromHash);

  /* Nothing plays until the section is actually on screen, and the active
     story replays whenever the visitor comes back to it. */
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        inView = en.isIntersecting;
        if(inView){ play(current); arm(); }
        else {
          panels.forEach(function(p){ if(p) p.classList.remove('play'); });
          clearInterval(auto);
        }
      });
    },{threshold:0.25}).observe(sec);
  } else {
    inView = true; play(0); arm();
  }

  /* One full panel animation is ~9s, so 10s gives each state time to
     reach its payoff before the next one starts. */
  var DWELL = 10000;

  function halt(){ stopped = true; clearInterval(auto); }

  function advance(){
    if(stopped || !inView || reduce.matches) return;
    autoMove = true;
    select((current + 1) % tabs.length);
    autoMove = false;
  }

  function arm(){
    clearInterval(auto);
    if(stopped || reduce.matches) return;
    auto = setInterval(advance, DWELL);
  }

  /* Used by the mobile arrows. Stepping by hand is a choice, so it stops the
     carousel exactly as clicking a tab does. */
  window.resolverSolveStep = function(dir){
    halt();
    select((current + dir + tabs.length) % tabs.length);
  };

  reduce.addEventListener && reduce.addEventListener('change', function(){ play(current); arm(); });
  fromHash();
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
(function(){
  var sec = document.getElementById('why');
  if(!sec) return;

  var reduce  = window.matchMedia('(prefers-reduced-motion: reduce)');
  var tabs    = [].slice.call(sec.querySelectorAll('.r3-navi'));
  var panels  = tabs.map(function(t){ return document.getElementById(t.getAttribute('aria-controls')); });
  var live    = document.getElementById('r3-gt');
  var prev    = document.getElementById('r3-prev');
  var next    = document.getElementById('r3-next');
  var deck    = document.getElementById('r3-deck');
  var stage   = sec.querySelector('.r3-stage');
  var navglow = sec.querySelector('.r3-navglow');
  var titles  = tabs.map(function(t){ return t.textContent.trim(); });
  var current = 0, entered = false;

  /* the glow shade follows the selected group; the arrows preview theirs */
  function setGlow(i){ sec.setAttribute('data-g', String(i)); }
  function moveNavGlow(){
    var t = tabs[current], nav = t.parentNode;
    navglow.style.width = t.offsetWidth + 'px';
    navglow.style.transform = 'translateX(' + (t.offsetLeft - nav.scrollLeft) + 'px)';
  }
  window.addEventListener('resize', moveNavGlow);
  tabs[0].parentNode.addEventListener('scroll', moveNavGlow, {passive:true});

  /* ── card activation: one at a time, the story plays once ── */
  function clear(panel){
    [].forEach.call(panel.querySelectorAll('.r3-card'), function(c){
      c.classList.remove('r3-act','r3-play');
      c.setAttribute('aria-expanded','false');
    });
    panel.classList.remove('r3-hasact');
    stage.classList.remove('r3-hot');
  }
  function activate(card){
    var panel = card.parentNode;
    if(card.classList.contains('r3-act')) return;
    clear(panel);
    panel.classList.add('r3-hasact');
    stage.classList.add('r3-hot');
    card.classList.add('r3-act');
    card.setAttribute('aria-expanded','true');
    if(reduce.matches) return;           // finished state, no replay
    void card.offsetWidth;               // reflow, so the story restarts
    card.classList.add('r3-play');
  }
  window.resolverWhyActivate = activate;

  [].forEach.call(sec.querySelectorAll('.r3-card'), function(card){
    card.addEventListener('mouseenter', function(){ activate(card); });
    card.addEventListener('focus',      function(){ activate(card); });
    card.addEventListener('click',      function(){ activate(card); });
    card.addEventListener('keydown',    function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(card); }
    });
  });
  [].forEach.call(sec.querySelectorAll('.r3-panel'), function(p){
    p.addEventListener('mouseleave', function(){ clear(p); });
  });

  /* ── group selection ── */
  function select(i, focus){
    if(i === current) { if(focus) tabs[i].focus(); return; }
    var back = i < current;
    panels.forEach(function(p,k){
      if(k === i){
        p.style.setProperty('--slide', back ? '-26px' : '26px');
        p.classList.add('on');
      } else {
        p.classList.remove('on');
        clear(p);
      }
    });
    current = i;
    tabs.forEach(function(t,k){
      t.setAttribute('aria-selected', String(k===i));
      t.tabIndex = k===i ? 0 : -1;
    });
    live.textContent = titles[i] + ', group ' + (i+1) + ' of ' + tabs.length;
    prev.disabled = (i === 0);
    next.disabled = (i === tabs.length-1);
    tabs[i].scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'});
    if(focus) tabs[i].focus();
    setGlow(i);
    moveNavGlow();
  }
  tabs.forEach(function(t,i){
    t.addEventListener('click', function(){ select(i); });
    t.addEventListener('keydown', function(e){
      var n = null;
      if(e.key === 'ArrowRight') n = Math.min(i+1, tabs.length-1);
      if(e.key === 'ArrowLeft')  n = Math.max(i-1, 0);
      if(e.key === 'Home')       n = 0;
      if(e.key === 'End')        n = tabs.length-1;
      if(n === null) return;
      e.preventDefault(); select(n, true);
    });
  });
  prev.addEventListener('click', function(){ select(Math.max(current-1, 0)); });
  next.addEventListener('click', function(){ select(Math.min(current+1, tabs.length-1)); });
  prev.disabled = true;

  /* hovering or focusing an arrow previews the group it would take you to */
  function preview(btn, dir){
    var to = function(){
      if(btn.disabled) return;
      setGlow(Math.min(Math.max(current + dir, 0), tabs.length-1));
    };
    var back = function(){ setGlow(current); };
    btn.addEventListener('mouseenter', to);
    btn.addEventListener('focus', to);
    btn.addEventListener('mouseleave', back);
    btn.addEventListener('blur', back);
  }
  preview(prev, -1); preview(next, 1);

  /* a second pair of arrows below the deck once the stage stacks */
  var arws = sec.querySelector('.r3-arws');
  arws.removeAttribute('aria-hidden');
  [prev, next].forEach(function(b){
    var c = b.cloneNode(true); c.removeAttribute('id');
    var w = document.createElement('span'); w.className = 'r3-arww';
    var g = document.createElement('i'); g.className = 'r3-aglow'; g.setAttribute('aria-hidden','true');
    w.appendChild(c); w.appendChild(g);
    c.addEventListener('click', function(){ b.click(); });
    new MutationObserver(function(){ c.disabled = b.disabled; })
      .observe(b, {attributes:true, attributeFilter:['disabled']});
    c.disabled = b.disabled;
    preview(c, b === prev ? -1 : 1);
    arws.appendChild(w);
  });

  /* ── swipe between groups ──
     Three gestures, guarded the same way: when the card row itself is
     horizontally scrollable (mobile), the cards are the thing being
     paged, so a group only changes once that row is at its edge. */
  function cardsScroll(){
    var p = panels[current];
    return p.scrollWidth - p.clientWidth > 4;
  }
  function step(dir){
    select(dir > 0 ? Math.min(current+1, tabs.length-1) : Math.max(current-1, 0));
  }

  var wLock = 0, wAcc = 0, wTimer = null;
  stage.addEventListener('wheel', function(e){
    if(Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   // vertical: let the page scroll
    if(cardsScroll()) return;
    e.preventDefault();
    var now = Date.now();
    if(now < wLock) return;
    wAcc += e.deltaX;
    clearTimeout(wTimer);
    wTimer = setTimeout(function(){ wAcc = 0; }, 200);
    if(Math.abs(wAcc) > 45){ step(wAcc); wAcc = 0; wLock = now + 620; }
  }, {passive:false});

  var dx0 = 0, dy0 = 0, dragging = false;
  stage.addEventListener('pointerdown', function(e){
    if(e.pointerType === 'touch' || e.button !== 0) return;
    if(cardsScroll() || e.target.closest('.r3-arw')) return;
    dx0 = e.clientX; dy0 = e.clientY; dragging = true;
  });
  window.addEventListener('pointerup', function(e){
    if(!dragging) return; dragging = false;
    var dx = e.clientX - dx0, dy = e.clientY - dy0;
    if(Math.abs(dx) < 70 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    step(-dx);
  });

  var sx = 0, sy = 0, sl = 0;
  stage.addEventListener('touchstart', function(e){
    var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY;
    sl = panels[current].scrollLeft;
  }, {passive:true});
  stage.addEventListener('touchend', function(e){
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if(Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
    var p = panels[current], room = p.scrollWidth - p.clientWidth;
    if(room < 4){ step(-dx); return; }
    if(dx < 0 && sl >= room - 2) step(1);
    if(dx > 0 && sl <= 2)        step(-1);
  }, {passive:true});

  /* ── entrance: centre card first, then the outer two ── */
  function enter(){
    if(entered) return; entered = true;
    if(reduce.matches) return;
    var cards = panels[0].querySelectorAll('.r3-card');
    [cards[1], cards[0], cards[2]].forEach(function(c,k){
      if(!c) return;
      c.style.opacity = '0';
      c.style.transform = 'translateY(14px)';
      setTimeout(function(){
        c.style.transition = 'opacity .5s ease, transform .55s cubic-bezier(.2,.7,.3,1)';
        c.style.opacity = ''; c.style.transform = '';
        setTimeout(function(){ c.style.transition = ''; }, 620);
      }, 150 + k*130);
    });
  }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      if(en[0].isIntersecting){ enter(); io.disconnect(); }
    }, {threshold:0.18});
    io.observe(sec);
  } else { entered = true; }

  moveNavGlow();
  setTimeout(moveNavGlow, 60);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(moveNavGlow);
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
(function(){
  var f = document.getElementById('demoform');
  if(!f) return;
  var alertBox = document.getElementById('tr-alert');
  var submitted = false;
  var btn = f.querySelector('button[type="submit"]');
  var btnLabel = btn ? btn.innerHTML : '';
  var NETMSG = 'We couldn’t send that just now. Please try again in a moment.';

  /* Where a failed enquiry goes instead. Same address as the demo CTA's
     fallback, so there is one inbox to watch rather than two. */
  var FALLBACK = 'care@helloklyk.com';

  /* Built with String.fromCharCode rather than a newline escape: this file is
     generated from Python, and an escaped newline here has been a source of
     broken JavaScript before. */
  var NL = String.fromCharCode(10);

  /* Somebody who has typed six fields and been told it did not send should not
     have to type them again. This hands them a pre-addressed email carrying the
     same answers, so the enquiry still reaches us.

     It is their own data going into their own mail client. Nothing is sent
     anywhere by building this link, and it is only ever built after a failure. */
  function fallbackHref(){
    function v(name){
      var el = f.querySelector('[name="' + name + '"]');
      if(!el || el.disabled) return '';
      return (el.value || '').trim();
    }
    var lines = [
      'Hi Resolver team,', '',
      'I’d like to request a trial for Resolver:', '',
      'First name: ' + v('first_name'),
      'Last name: ' + v('last_name'),
      'Work email: ' + v('email'),
      'Job title: ' + v('job_title'),
      'Company: ' + v('company'),
      'Company size: ' + v('company_size')
    ];
    /* The conditional questions only exist above 25 people, and are disabled
       when hidden, so they are added only when they were actually answered. */
    if(v('it_support')) lines.push('How we manage IT support: ' + v('it_support'));
    if(v('chat'))       lines.push('Workplace chat: ' + v('chat'));
    /* Signed with the name they already typed. The placeholder stays only if
       both name fields are somehow empty, so the sign-off is never blank. */
    var who = (v('first_name') + ' ' + v('last_name')).trim();
    lines.push('', 'Thanks,', who || '[Name]');

    return 'mailto:' + FALLBACK
         + '?subject=' + encodeURIComponent('Resolver trial request')
         + '&body=' + encodeURIComponent(lines.join(NL));
  }

  // keep the placeholder option greyed until a real choice is made
  [].slice.call(f.querySelectorAll('select')).forEach(function(sel){
    var sync = function(){ sel.classList.toggle('ph', !sel.value); };
    sel.addEventListener('change', sync); sync();
  });

  /* ── free and disposable email domains ────────────────────────────────
     The HubSpot form blocks these already, but it does it after the
     submission has travelled, and it answers with an error the visitor never
     sees. Checking here turns a dead end into a sentence they can act on.
     HubSpot's own list runs to thousands of entries; this is the part of it
     that people actually type, and anything missed is still refused by
     HubSpot, which is handled further down. */
  var FREEMAIL = ('gmail.com googlemail.com yahoo.com yahoo.co.uk yahoo.co.in yahoo.fr yahoo.de '
    + 'yahoo.it yahoo.es yahoo.ca yahoo.com.au yahoo.com.br yahoo.co.jp ymail.com rocketmail.com '
    + 'hotmail.com hotmail.co.uk hotmail.fr hotmail.de hotmail.it hotmail.es hotmail.ca '
    + 'hotmail.com.au outlook.com outlook.fr outlook.de outlook.es outlook.it outlook.com.au '
    + 'live.com live.co.uk live.fr live.de live.it live.ca live.com.au msn.com passport.com '
    + 'icloud.com me.com mac.com aol.com aim.com netscape.net compuserve.com '
    + 'gmx.com gmx.de gmx.net gmx.at gmx.ch web.de t-online.de freenet.de arcor.de '
    + 'protonmail.com protonmail.ch proton.me pm.me tutanota.com tutanota.de tuta.io '
    + 'zoho.com zohomail.com yandex.com yandex.ru yandex.ua ya.ru mail.ru inbox.ru bk.ru list.ru '
    + 'mail.com email.com usa.com consultant.com engineer.com techie.com writeme.com post.com '
    + 'qq.com 163.com 126.com sina.com sina.cn sohu.com 139.com 189.cn foxmail.com '
    + 'naver.com hanmail.net daum.net nate.com '
    + 'orange.fr wanadoo.fr free.fr laposte.net sfr.fr neuf.fr bbox.fr numericable.fr '
    + 'libero.it virgilio.it alice.it tiscali.it tin.it fastwebnet.it '
    + 'terra.com.br uol.com.br bol.com.br ig.com.br globo.com '
    + 'btinternet.com sky.com talktalk.net virginmedia.com ntlworld.com blueyonder.co.uk '
    + 'tiscali.co.uk fsmail.net o2.co.uk orange.net plus.com '
    + 'telus.net shaw.ca rogers.com bell.net sympatico.ca videotron.ca '
    + 'bigpond.com bigpond.net.au optusnet.com.au iinet.net.au tpg.com.au '
    + 'comcast.net verizon.net att.net sbcglobal.net bellsouth.net cox.net charter.net '
    + 'earthlink.net juno.com roadrunner.com rr.com optonline.net frontier.com '
    + 'fastmail.com fastmail.fm hushmail.com hush.com runbox.com posteo.de mailfence.com '
    + 'seznam.cz centrum.cz atlas.cz post.cz wp.pl o2.pl onet.pl interia.pl op.pl '
    + 'abv.bg mail.bg rediffmail.com sify.com indiatimes.com '
    + 'mailinator.com guerrillamail.com sharklasers.com 10minutemail.com 10minutemail.net '
    + 'temp-mail.org tempmail.com yopmail.com trashmail.com throwawaymail.com getnada.com '
    + 'maildrop.cc dispostable.com fakeinbox.com mytemp.email spamgourmet.com mailnesia.com '
    + 'moakt.com emailondeck.com tempr.email discard.email spam4.me grr.la').split(' ');

  var FREESET = {};
  for(var fi = 0; fi < FREEMAIL.length; fi++) FREESET[FREEMAIL[fi]] = 1;

  var ERR_FORMAT = 'Please enter a valid work email address.';
  var ERR_FREE   = 'Please use your work email address — we can’t accept '
                 + 'personal email providers.';

  /* '' when the address is usable, otherwise which of the two is wrong */
  function emailReason(v){
    v = (v || '').trim().toLowerCase();
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return 'format';
    return FREESET[v.split('@').pop()] ? 'free' : '';
  }

  function wrap(el){ return el.closest('.field'); }
  function valid(el){
    if(el.type === 'email') return !el.value ? !el.required : !emailReason(el.value);
    if(!el.required) return true;
    if(!el.value) return false;
    return el.value.trim().length > 0;
  }
  function mark(el){
    var ok = valid(el), w = wrap(el);
    if(!w) return ok;
    w.classList.toggle('bad', !ok);
    el.setAttribute('aria-invalid', ok ? 'false' : 'true');
    var err = w.querySelector('.tr-err');
    if(err){
      if(el.type === 'email' && !ok){
        err.textContent = emailReason(el.value) === 'free' ? ERR_FREE : ERR_FORMAT;
      }
      if(ok) el.removeAttribute('aria-describedby');
      else el.setAttribute('aria-describedby', err.id);
    }
    return ok;
  }
  var controls = [].slice.call(f.querySelectorAll('input,select'));
  controls.forEach(function(el){
    el.addEventListener('blur', function(){
      if(submitted) mark(el);
      var f = el.closest('.field');
      if(f) f.classList.toggle('good', !!el.required && !el.disabled && valid(el) && !!el.value);
    });
    el.addEventListener('input', function(){ if(submitted && valid(el)) mark(el); });
    el.addEventListener('change', function(){ if(submitted) mark(el); });
  });

  // Conditional questions for larger companies. The block is intentionally
  // empty — it is only ever revealed once real fields are added to it, so a
  // visitor never sees an empty area.
  var cond = document.getElementById('tr-cond');
  var size = document.getElementById('f-size');
  var TRIGGER = ['26-50','51-100','101-250','251-500','500+'];
  function revealCond(){
    if(!cond || !size) return;
    var on = TRIGGER.indexOf(size.value) > -1 && cond.children.length > 0;
    cond.hidden = !on;
    [].slice.call(cond.querySelectorAll('input,select')).forEach(function(el){ el.disabled = !on; });
  }
  if(size) size.addEventListener('change', revealCond);
  revealCond();

  f.addEventListener('submit', function(e){
    e.preventDefault();
    submitted = true;
    var bad = controls.filter(function(el){ return !el.disabled && !mark(el); });
    if(bad.length){
      if(alertBox){
        alertBox.textContent = bad.length === 1
          ? 'There is 1 answer still to fill in.'
          : 'There are ' + bad.length + ' answers still to fill in.';
        alertBox.hidden = false;
      }
      bad[0].focus();
      return;
    }
    if(alertBox){ alertBox.hidden = true; alertBox.textContent = ''; }
    send();
  });

  /* ── HubSpot ────────────────────────────────────────────────────────────
     The form keeps its own markup and styling and posts straight to the
     HubSpot Forms API, so nothing about the design depends on HubSpot's
     embed. HS.map pairs each field on this form with the internal property
     name on the HubSpot form; a blank entry is skipped until the internal
     name is confirmed.                                                    */
  var HS = {
    portalId: '26003526',
    formGuid: 'a0b06f78-5169-45fb-8320-9d638e2e7343',
    region:   'eu1',
    /* The portal's "Marketing Information" subscription. HubSpot names the
       matching contact property hs_email_optout_144310125, and the number on
       the end of that property IS the subscription type id. */
    subscriptionTypeId: 144310125,
    /* The notice actually shown beside the button, word for word, so what
       HubSpot stores is what the person was told at the point of giving it. */
    processText: 'We’ll use your details to contact you about Resolver and your '
                 + 'trial, in accordance with our Privacy Policy.',
    marketingText: 'I’d also like occasional emails from Klyk about Resolver '
                 + 'and related services. Unsubscribe at any time.',
    /* Optional. If the HubSpot form also carries its own checkbox property for
       the opt-in — the one whose internal name HubSpot generated from the
       label — put that internal name here and the tick is posted as a field
       too, as an explicit 'true' or 'false'. Left blank, the subscription above
       is the single record of marketing consent, which is the safer arrangement:
       two records of the same consent can disagree, and then nobody knows which
       one is allowed to send. */
    optInField: '',
    /* Optional. The legal basis HubSpot records comes from which consent shape
       we post. The 'consent' shape below makes HubSpot write "Freely given
       consent from contact", which is not what the page says happened — there
       is no tick for processing. HubSpot's other shape writes legitimate
       interest instead:

         legitimateInterest: { value, subscriptionTypeId, legalBasis, text }
         legalBasis is an enum of exactly two values, "LEAD" or "CUSTOMER".
         "LEAD" is the one that lands as Legitimate interest – prospect/lead.

       The catch is that value MUST be true and a subscriptionTypeId is
       required, so this shape always subscribes the person to whatever type it
       names. It therefore cannot point at Marketing Information (144310125) —
       that would subscribe everyone regardless of the tick. Point it at a
       separate non-marketing subscription instead, the one covering trial
       correspondence, and the marketing tick carries on being handled by the
       consent block.

       Left blank, nothing changes. Put a subscription type id here and the
       block is posted alongside the consent block. Whether HubSpot accepts
       both at once is undocumented, so if it refuses, the submission is
       retried without this block and the enquiry still lands — check the
       browser console, or add ?debug=1 to see what it said. */
    liSubscriptionTypeId: 144741839,
    map: {
      'f-first': 'firstname',
      'f-last':  'lastname',
      'f-email': 'email',
      'f-title': 'jobtitle',
      'f-co':    'company',
      /* The HubSpot form uses its own property here rather than the standard
         numberofemployees, and marks it required — sending the standard one
         meant the required field arrived empty and the submission was refused.
         Note the trailing underscore; it is part of the name. */
      'f-size':  'how_many_people_work_at_your_company_',
      'f-itsup': 'how_do_you_manage_it_support_today',
      'f-chat':  'which_workplace_chat_does_your_team_use'
    }
  };
  var endpoint = 'https://api-' + HS.region + '.hsforms.com' +
                 '/submissions/v3/integration/submit/' +
                 HS.portalId + '/' + HS.formGuid;

  function hutk(){
    var m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return m ? decodeURIComponent(m[2]) : '';
  }

  /* Field names HubSpot has rejected on this page load, so a later edit to
     the HubSpot form can never cost a lead: the offending property is
     dropped and the rest of the submission is retried. email is never
     dropped &#8212; without it there is nothing to follow up. */
  var dropped = {};
  /* set if HubSpot refuses the legitimate-interest block, so the retry
     leaves it out rather than losing the enquiry */
  var liDropped = false;

  function payload(){
    var fields = [];
    controls.forEach(function(el){
      if(el.disabled || el.type === 'checkbox') return;
      /* A question inside a hidden block was never asked, so it has no answer
         to give. Belt and braces alongside el.disabled: if the block is closed
         for any reason, nothing inside it is posted. */
      if(el.closest && el.closest('.tr-cond') && el.closest('.tr-cond').hidden) return;
      var name = HS.map[el.id];
      var val  = (el.value || '').trim();
      if(!name || !val || dropped[name]) return;
      /* A select that is still on its placeholder reports an empty value, so
         it is already skipped above. This catches the other way round: a
         placeholder whose label somehow arrives as the value. HubSpot rejects
         it as an option that does not exist, and the whole submission with it. */
      if(el.tagName === 'SELECT'){
        var ph = el.options && el.options[0];
        if(ph && ph.value === '' && val === (ph.textContent || '').trim()) return;
      }
      fields.push({ objectTypeId: '0-1', name: name, value: val });
    });

    var mkt = document.getElementById('f-mkt');
    var ticked = !!(mkt && mkt.checked);

    /* If the HubSpot form also carries its own checkbox property, post it as a
       field with an explicit value either way, so an untick is recorded rather
       than simply absent. An absent field leaves whatever was on the contact
       before, which is how somebody who has opted out keeps getting email. */
    if(HS.optInField && !dropped[HS.optInField]){
      fields.push({ objectTypeId: '0-1', name: HS.optInField,
                    value: ticked ? 'true' : 'false' });
    }

    var ctx = { pageUri: location.href, pageName: document.title };
    var k = hutk();
    if(k) ctx.hutk = k;

    /* ── the lawful basis, written down ───────────────────────────────────
       Two separate things, recorded separately:

       consentToProcess carries the notice shown above the button word for
       word. Replying to the request, arranging the trial and following up on
       it are what the person asked for by sending the form, so they do not
       wait on a tick — what matters under the GDPR is that the purpose was
       stated plainly before they sent it, which is what this stores.

       communications is the marketing subscription, and that DOES turn on the
       tick. It is now always sent, with value true or false, so an untick is
       an explicit opt-out against subscription 144310125 rather than silence.
       Silence would leave an older opt-in standing. */
    var consent = { consentToProcess: true, text: HS.processText };
    var comm = { value: ticked, text: HS.marketingText };
    if(HS.subscriptionTypeId) comm.subscriptionTypeId = HS.subscriptionTypeId;
    consent.communications = [comm];

    var lco = { consent: consent };
    if(HS.liSubscriptionTypeId && !liDropped){
      lco.legitimateInterest = {
        value: true,
        subscriptionTypeId: HS.liSubscriptionTypeId,
        legalBasis: 'LEAD',
        text: HS.processText
      };
    }

    return { submittedAt: Date.now(), fields: fields, context: ctx,
             legalConsentOptions: lco };
  }

  /* Add ?debug=1 to the page's address to see exactly what HubSpot said,
     in the alert itself, without opening developer tools. Visitors never see
     it; it is only ever shown when that parameter is present. */
  var DEBUG = /[?&]debug=1\b/.test(location.search) || location.hash === '#debug';

  /* offerEmail: only for a failure the visitor cannot fix themselves. A
     rejected email address is not one of those — there the useful action is to
     correct the field, and an escape route would just talk them out of it. */
  function fail(msg, detail, offerEmail){
    f.classList.remove('sending');
    if(btn){ btn.disabled = false; btn.innerHTML = btnLabel; }
    if(alertBox){
      alertBox.textContent = msg;
      if(offerEmail){
        var alt = document.createElement('span');
        alt.className = 'tr-alt';
        alt.appendChild(document.createTextNode('Or email '));
        var a = document.createElement('a');
        a.href = fallbackHref();
        a.textContent = FALLBACK;
        alt.appendChild(a);
        alt.appendChild(document.createTextNode(
          ' and we’ll set your trial up from there — your answers are '
          + 'already in the message.'));
        alertBox.appendChild(alt);
      }
      if(DEBUG && detail){
        var pre = document.createElement('span');
        pre.style.cssText = 'display:block;margin-top:10px;font-family:var(--mono);'
          + 'font-size:12px;line-height:1.5;white-space:pre-wrap;word-break:break-word;'
          + 'opacity:.85';
        pre.textContent = detail;
        alertBox.appendChild(pre);
      }
      alertBox.hidden = false;
      alertBox.focus();
    }
  }

  /* everything HubSpot told us, flattened into something readable */
  function explain(status, d){
    var out = ['HTTP ' + status];
    if(d){
      if(d.message) out.push(d.message);
      if(d.errorType) out.push('type: ' + d.errorType);
      var errs = d.errors || [];
      for(var i = 0; i < errs.length; i++){
        out.push('• ' + (errs[i].errorType ? errs[i].errorType + ' — ' : '')
                 + (errs[i].message || JSON.stringify(errs[i])));
      }
      if(out.length === 1) out.push(JSON.stringify(d).slice(0, 600));
    }
    return out.join('\n');
  }

  function done(){
    f.classList.remove('sending');
    f.classList.add('sent');
    var ok = f.querySelector('.ok');
    if(ok){ ok.setAttribute('tabindex','-1'); ok.focus(); }

    /* Announce it and stop caring what listens. The conversion-event block in
       the page head turns this into a GA4 event and, where the visitor
       accepted advertising cookies, a LinkedIn conversion. Deliberately fired
       here rather than on submit: this point is reached only after HubSpot
       accepted the submission, so a counted conversion is a real one. */
    try {
      document.dispatchEvent(new CustomEvent('resolver:trial-submitted'));
    } catch(e) {
      /* CustomEvent constructor missing on a very old browser. The form has
         already succeeded; losing the count is not worth an error. */
    }
  }

  /* Pull the property names out of a HubSpot 400 so we know what to drop.
     Its errors read: "Error in 'fields.numberofemployees'. ..." */
  function badFields(d){
    var out = [], errs = (d && d.errors) || [];
    for(var i = 0; i < errs.length; i++){
      var m = /fields\.([A-Za-z0-9_]+)/.exec(errs[i] && errs[i].message || '');
      if(m && m[1] !== 'email' && !dropped[m[1]]) out.push(m[1]);
    }
    return out;
  }

  function send(attempt){
    if(!window.fetch){ fail(NETMSG, null, true); return; }
    attempt = attempt || 1;
    f.classList.add('sending');
    if(btn){ btn.disabled = true; btn.textContent = 'Sending…'; }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload())
    }).then(function(r){
      if(r.ok){ done(); return; }
      return r.json().catch(function(){ return null; }).then(function(d){
        if(window.console) console.error('HubSpot rejected the submission', r.status, d);
        /* HubSpot blocks the full list server-side. If it refuses the
           address, say why rather than blaming the connection. */
        if(r.status === 400 && /email/i.test(JSON.stringify(d || '')) &&
           /blocked|free|domain/i.test(JSON.stringify(d || ''))){
          var em = document.getElementById('f-email');
          if(em){
            var ew = em.closest('.field'), ee = ew && ew.querySelector('.tr-err');
            if(ee) ee.textContent = ERR_FREE;
            if(ew) ew.classList.add('bad');
            em.setAttribute('aria-invalid', 'true');
            em.focus();
          }
          fail(ERR_FREE);
          return;
        }
        /* A refusal naming the consent options is almost certainly the
           legitimate-interest block, which is the one experimental part of
           this payload. Drop it and try again rather than lose the enquiry. */
        if(r.status === 400 && !liDropped && HS.liSubscriptionTypeId &&
           /legitimateInterest|legalConsent|legalBasis|subscriptionType/i.test(JSON.stringify(d || ''))){
          liDropped = true;
          if(window.console){
            console.warn('HubSpot refused the legitimate-interest block; '
              + 'retrying without it. The contact will record as consent instead.');
          }
          send(attempt + 1);
          return;
        }
        var bad = r.status === 400 && attempt < 3 ? badFields(d) : [];
        if(bad.length){
          for(var i = 0; i < bad.length; i++) dropped[bad[i]] = true;
          if(window.console){
            console.warn('Retrying without ' + bad.join(', ') +
              ' — these no longer match the HubSpot form. The enquiry is still sent.');
          }
          send(attempt + 1);
          return;
        }
        fail(NETMSG, explain(r.status, d), true);
      });
    }).catch(function(err){
      if(window.console) console.error('HubSpot submission failed', err);
      fail(NETMSG, 'Request never reached HubSpot: ' + (err && err.message || err), true);
    });
  }
})();

(function(){
  var n = document.getElementById('tr-next');
  if(!n || !window.IntersectionObserver) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ n.classList.add('play'); io.disconnect(); } });
  }, {threshold:.25});
  io.observe(n);
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* Both stories play once, when the section first comes into view. The resting
   CSS is the finished state, so nothing is hidden if they never run. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce || !window.IntersectionObserver) return;
  ['human','value'].forEach(function(id){
    var sec = document.getElementById(id);
    if(!sec) return;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ sec.classList.add('play'); io.disconnect(); } });
    }, {threshold:.2});
    io.observe(sec);
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
(function(){
  var sec = document.getElementById('proof');
  if(!sec) return;
  var reduce = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- customer-language strip: one word in emphasis at a time ---- */
  var strip = document.getElementById('kk-strip');
  if(strip){
    var items = [].slice.call(strip.querySelectorAll('.kk-word'));
    var wi = 0, timer = null;
    function setWord(n){
      wi = (n + items.length) % items.length;
      items.forEach(function(li, i){
        var on = i === wi;
        li.classList.toggle('kk-on', on);
        li.querySelector('.kk-wb').setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function start(){
      if(reduce || timer) return;
      timer = setInterval(function(){ setWord(wi + 1); }, 3000);
    }
    items.forEach(function(li, i){
      li.querySelector('.kk-wb').addEventListener('click', function(){
        stop(); setWord(i);
      });
    });
    strip.addEventListener('mouseenter', stop);
    strip.addEventListener('mouseleave', start);
    strip.addEventListener('focusin', stop);
    if(!reduce && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es, o){
        es.forEach(function(e){ if(e.isIntersecting){ start(); o.unobserve(e.target); } });
      }, {threshold:.4}).observe(strip);
    }
  }

  /* ---- headshots: fall back to the initials if one cannot load ---- */
  [].slice.call(sec.querySelectorAll('.kk-av img')).forEach(function(im){
    function drop(){ if(im.parentNode) im.parentNode.removeChild(im); }
    im.addEventListener('error', drop);
    if(im.complete && im.naturalWidth === 0) drop();
  });

  /* ---- proof figures: count up once, when the band comes into view ---- */
  var figs = [].slice.call(sec.querySelectorAll('.kk-fig b')).map(function(b){
    var m = b.textContent.trim().match(/^([^0-9]*)([0-9][0-9,.]*)(.*)$/);
    if(!m) return null;
    var digits = m[2].split('.')[1];
    var f = { el:b, pre:m[1], suf:m[3], end:parseFloat(m[2].replace(/,/g,'')),
              dec:digits ? digits.length : 0, done:false };
    b.style.minWidth = Math.ceil(b.getBoundingClientRect().width) + 'px';
    return f;
  }).filter(Boolean);

  function countUp(){
    if(reduce) return;
    figs.forEach(function(f, i){
      if(f.done) return;
      f.done = true;
      var dur = 1150, delay = 120 + i * 110, t0 = null;
      f.el.textContent = f.pre + (0).toFixed(f.dec) + f.suf;
      function step(ts){
        if(t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        f.el.textContent = f.pre + (f.end * e).toFixed(f.dec) + f.suf;
        if(p < 1){ requestAnimationFrame(step); }
        else { f.el.textContent = f.pre + f.end.toFixed(f.dec) + f.suf; }
      }
      setTimeout(function(){ requestAnimationFrame(step); }, delay);
    });
  }

  /* ---- client strip: manual scrolling, arrows only ---- */
  var track = document.getElementById('kk-ctrack');
  var cprev = document.getElementById('kk-cprev');
  var cnext = document.getElementById('kk-cnext');
  if(track && cprev && cnext){
    function sync(){
      var max = track.scrollWidth - track.clientWidth;
      cprev.disabled = track.scrollLeft <= 1;
      cnext.disabled = track.scrollLeft >= max - 1;
    }
    function nudge(dir){ track.scrollLeft += dir * Math.round(track.clientWidth * .8); }
    cprev.addEventListener('click', function(){ nudge(-1); });
    cnext.addEventListener('click', function(){ nudge(1); });
    track.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---- testimonial carousel ---- */
  var tst = document.getElementById('kk-tst');
  if(tst){
    var slides = [].slice.call(tst.querySelectorAll('.kk-t'));
    var dots   = [].slice.call(tst.querySelectorAll('.kk-dot'));
    var ti = 0;
    function show(n){
      ti = (n + slides.length) % slides.length;
      slides.forEach(function(s, i){
        var on = i === ti;
        s.classList.toggle('kk-on', on);
        if(on){ s.removeAttribute('hidden'); } else { s.setAttribute('hidden',''); }
      });
      dots.forEach(function(d, i){
        var on = i === ti;
        d.classList.toggle('kk-on', on);
        if(on){ d.setAttribute('aria-current','true'); }
        else { d.removeAttribute('aria-current'); }
      });
    }
    /* auto-advance: slow, pauses on hover or focus, and any manual
       interaction hands control to the reader for good */
    var tTimer = null, taken = false;
    function tStop(){ if(tTimer){ clearInterval(tTimer); tTimer = null; } }
    function tStart(){
      if(reduce || taken || tTimer) return;
      tTimer = setInterval(function(){ show(ti + 1); }, 7000);
    }
    function manual(n){ taken = true; tStop(); show(n); }

    var prev = document.getElementById('kk-prev');
    var next = document.getElementById('kk-next');
    if(prev) prev.addEventListener('click', function(){ manual(ti - 1); });
    if(next) next.addEventListener('click', function(){ manual(ti + 1); });
    dots.forEach(function(d, i){
      d.addEventListener('click', function(){ manual(i); });
    });
    tst.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ manual(ti - 1); }
      else if(e.key === 'ArrowRight'){ manual(ti + 1); }
    });
    tst.addEventListener('mouseenter', tStop);
    tst.addEventListener('mouseleave', tStart);
    tst.addEventListener('focusin', tStop);
    if(!reduce && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es, ob){
        es.forEach(function(e){
          if(e.isIntersecting){ tStart(); ob.unobserve(e.target); }
        });
      }, {threshold:.35}).observe(tst);
    }
  }

  /* ---- one-shot entry ---- */
  if(!reduce && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es, o){
      es.forEach(function(e){
        if(e.isIntersecting){ sec.classList.add('play'); countUp(); o.unobserve(e.target); }
      });
    }, {threshold:.12}).observe(sec);
  }
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }

try {
/* ── video lightbox ──────────────────────────────────────────────────────
   Clicking a film opens it large in the middle of the screen over a dimmed
   page, with a close button. Esc, the close button or a click on the dimmed
   area returns to the page. With the script off, the films keep their
   normal inline controls. */
(function(){
  var root = document.getElementById('resolver-page');
  var vids = [].slice.call(document.querySelectorAll('#resolver-page .vid video'));
  if(!root || !vids.length) return;

  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" '
        + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<path d="M6 6l12 12M18 6 6 18"/></svg>';

  var lb = document.createElement('div');
  lb.className = 'rsvp-lb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-hidden', 'true');
  lb.innerHTML = '<div class="rsvp-lb-box">'
               +   '<button type="button" class="rsvp-lb-x" aria-label="Close video">' + X + '</button>'
               +   '<div class="rsvp-lb-frame"></div>'
               +   '<p class="rsvp-lb-cap"></p>'
               + '</div>';
  root.appendChild(lb);

  var frame = lb.querySelector('.rsvp-lb-frame');
  var cap   = lb.querySelector('.rsvp-lb-cap');
  var close = lb.querySelector('.rsvp-lb-x');
  var lastFocus = null, current = null, scrollLock = '';

  function open(v){
    var card  = v.closest ? v.closest('.vid') : null;
    var title = card && card.querySelector('.m b');
    var kicker = card && card.querySelector('.m .k');
    var src = v.getAttribute('src') || v.currentSrc || '';

    current = document.createElement('video');
    current.controls = true;
    current.playsInline = true;
    current.setAttribute('playsinline', '');
    current.preload = 'auto';
    if(v.getAttribute('poster')) current.poster = v.getAttribute('poster');
    if(src) current.src = src;
    frame.innerHTML = '';
    frame.appendChild(current);

    cap.innerHTML = '';
    if(kicker){ var k = document.createElement('span'); k.textContent = kicker.textContent; cap.appendChild(k); }
    if(title){ cap.appendChild(document.createTextNode(title.textContent)); }
    lb.setAttribute('aria-label', title ? title.textContent : 'Video');

    lastFocus = document.activeElement;
    scrollLock = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    lb.setAttribute('aria-hidden', 'false');
    lb.classList.add('open');
    close.focus();

    if(src){
      var p = current.play();
      if(p && p.catch) p.catch(function(){ /* autoplay refused: the controls are there */ });
    }
  }

  function shut(){
    if(!lb.classList.contains('open')) return;
    lb.classList.remove('open');
    lb.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = scrollLock;
    if(current){
      try { current.pause(); } catch(e){}
      current.removeAttribute('src');
      try { current.load(); } catch(e){}   /* stop it downloading in the background */
      current = null;
    }
    setTimeout(function(){ if(!lb.classList.contains('open')) frame.innerHTML = ''; }, 250);
    if(lastFocus && lastFocus.focus){ try { lastFocus.focus({preventScroll:true}); } catch(e){} }
  }

  vids.forEach(function(v){
    var ph = v.parentNode;
    var card = v.closest ? v.closest('.vid') : null;
    var title = card && card.querySelector('.m b');

    /* the inline film becomes a poster with a play button; it never plays in place */
    v.removeAttribute('controls');
    v.controls = false;
    v.setAttribute('tabindex', '-1');
    v.setAttribute('aria-hidden', 'true');
    v.addEventListener('play', function(){ v.pause(); });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rsvp-play';
    btn.setAttribute('aria-label', 'Play video' + (title ? ': ' + title.textContent : ''));
    btn.addEventListener('click', function(){ open(v); });
    ph.appendChild(btn);
  });

  close.addEventListener('click', shut);
  lb.addEventListener('click', function(e){ if(e.target === lb) shut(); });
  document.addEventListener('keydown', function(e){
    if(!lb.classList.contains('open')) return;
    if(e.key === 'Escape'){ e.preventDefault(); shut(); return; }
    if(e.key === 'Tab'){
      /* keep focus inside the dialog: the close button and the player */
      var f = [close].concat(current ? [current] : []);
      var i = f.indexOf(document.activeElement);
      if(e.shiftKey && i <= 0){ e.preventDefault(); f[f.length - 1].focus(); }
      else if(!e.shiftKey && i === f.length - 1){ e.preventDefault(); f[0].focus(); }
    }
  });
})();
} catch (e) { if (window.console) console.error("[resolver-landing]", e); }